module.exports = __webpack_public_path__ + "img/volleyball-ball.b08a6508.svg";